// import React, { useState, useEffect, useCallback, useRef } from "react";
// import { useFetchSrcmApi } from "gatsby-plugin-hfn-profile/fetch-srcm-api";
// import { selectorSrcmProfile } from "gatsby-plugin-hfn-profile/state/selectors";
// import getFormattedDate from "sites-common/utils/FormatDate";
// import { Link, navigate } from "gatsby";
// import "../../assets/styles/eventDetails.scss";
// import { useSelector, useDispatch } from "react-redux";
// import PropTypes from "prop-types";
// import {
//   resetState,
//   openParticipantsPanel,
// } from "gatsby-plugin-hfn-profile/state/action_participants_panel";
// import { get } from "sites-common/utils/lodash";
// import PeopleSelectionForm from "gatsby-plugin-hfn-profile/components/ParticipantsPanel";

// import { copyKeys } from "sites-common/utils/copyKeys";
// import EventSummary from "gatsby-plugin-hfn-profile/components/EventSummary";
// import { useAlert } from "gatsby-plugin-hfn-profile/alert";
// import Loader from "react-loader-spinner";
// import { useFirebase } from "react-redux-firebase";
// import EventRegistrations from "gatsby-plugin-hfn-profile/components/EventRegistrations";
// import { new_pnr, ref, styles } from "../../assets/data/visitorRegistration";
// import Layout from "../../layout";
// import Seo from "../../components/seo";
// import Breadcrumb from "../../components/Breadcrumb";
// import {
//   summaryStyles,
//   validateAgeGroup,
// } from "../../assets/data/registrationConfig";
// import PricingDetails from "./PricingDetails";

// const computePnrPageUrl = ({ pnr, eventId }) =>
//   `/pnr?pnr=${pnr}&eventId=${eventId}`;

// const EventDetails = ({ location }) => {
//   const [eventDetail, setEventDetail] = useState({});
//   const [prefetchedData, setPrefetchedData] = useState(null);
//   const [favouritesList, setFavouritesList] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [fetchPnr, setFetchPnr] = useState(null);
//   const params = new URLSearchParams(location.search);
//   const srcmProfile = useSelector(selectorSrcmProfile);
//   const { fetchSrcmApi } = useFetchSrcmApi();
//   const dispatch = useDispatch();
//   const { showAlert } = useAlert();
//   const [pricingData, setPricingList] = useState({
//     loading: true,
//     s: [],
//   });
//   const [selectedSku, setSelectedSku] = useState(null);
//   const [loadingMessage, setLoadingMessage] = useState("");

//   const participantsAllowList = {
//     srcmid: "Abhyasis with SRCM / HFN ID cards",
//     otherid: "Anyone with some Govt issued ID Cards",
//     child: "Children",
//     noid: "Anyone without any ID cards",
//   };
//   // const showPois = {
//   //   other: true,
//   //   aadhar: true,
//   // };
//   const eventId = params.get("eventId");
//   const PageSize = 1500;
//   const firebase = useFirebase();
//   const shopventory = useRef(null);

//   const breadCrumbs = [
//     {
//       id: 1,
//       label: "Home",
//       url: "/",
//     },
//     {
//       id: 2,
//       label: "Events",
//       url: `/events`,
//     },
//     {
//       id: 3,
//       label: "Event Details",
//       url: "/events/summary/",
//     },
//   ];

//   useEffect(() => {
//     if (!shopventory.current) {
//       shopventory.current = firebase.functions().httpsCallable("shopventory");
//     }
//   }, [firebase]);

//   useEffect(() => {
//     if (localStorage.getItem("currentPnr")) {
//       localStorage.setItem("currentPnr", null);
//     }
//   }, []);

//   useEffect(() => {
//     fetchSrcmApi({
//       api: `/api/v2/me/userdata/`,
//       client: "eventsClient",
//     })
//       .then((data) => {
//         setFavouritesList(data.results);
//       })
//       .catch(() => {});
//   }, [fetchSrcmApi]);

//   const addNewSale = useCallback(
//     (evD, skuData, pnr = null, data = []) => {
//       if (skuData && skuData.sku && data.length) {
//         const noOfPerson = data.length;
//         const { org, sku, currency } = skuData;
//         const { address, email, name, phone } = srcmProfile;

//         const getStock = new Promise((resolve) => {
//           shopventory
//             .current({
//               request: "get-stocks",
//               payload: { stock_group: evD.name },
//             })
//             .then((result) => {
//               resolve(result);
//             });
//         });

//         getStock.then((result) => {
//           const pg = result.data.pg.find((item) => item.org === skuData.org);
//           if (pg) {
//             shopventory
//               .current({
//                 request: "new-sale",
//                 payload: {
//                   stock_org: org,
//                   stock_pg: pg.key,
//                   stock_group: evD.name,
//                   sale_cart: [{ sku, qty: noOfPerson, stock_group: evD.name }],
//                   sale_purpose: "Event registration",
//                   sale_amount: skuData.rate * noOfPerson,
//                   sale_currency: currency,
//                   buyer_name: name,
//                   buyer_email: email,
//                   buyer_phone: phone,
//                   buyer_address: address,
//                   buyer_pnr: pnr,
//                   redirect_uri: `${location.origin}/events/summary?pnr=${pnr}`,
//                 },
//               })
//               .then((r) => {
//                 if (r.data.payment_url) {
//                   navigate(r.data.payment_url);
//                 } else {
//                   setLoading(false);
//                 }
//               });
//           } else {
//             setLoading(false);
//           }
//         });
//       }
//     },
//     [srcmProfile, location]
//   );

//   const getRegistrations = useCallback(
//     (pnrx) => {
//       if (pnrx) {
//         fetchSrcmApi({
//           api: `/api/v2/event-registrations/`,
//           methodParams: { pnr: pnrx },
//           client: "eventsClient",
//         }).then((data) => {
//           setPrefetchedData(data.results);
//         });
//         setFetchPnr(pnrx);
//       }
//       return null;
//     },
//     [fetchSrcmApi]
//   );

//   const addToFavourites = (person) => {
//     let contains = false;
//     favouritesList.forEach((item) => {
//       if (item.data.full_name === person.full_name) {
//         contains = true;
//       }
//       return item;
//     });
//     if (!contains) {
//       fetchSrcmApi({
//         api: `/api/v2/me/userdata/`,
//         method: "POST",
//         methodParams: { data: person },
//         client: "eventsClient",
//       })
//         .then(() => {
//           setLoading(false);
//         })
//         .catch(() => {});
//     }
//     return null;
//   };

//   const onRegistrationCallback = (participantsData) => {
//     setLoading(true);
//     if (eventDetail.is_paid_event) {
//       setLoadingMessage("Registration in process");
//     }
//     const addData = {
//       pnr: fetchPnr || new_pnr(srcmProfile?.email),
//       ref,
//     };
//     const body = [];
//     participantsData.map((item) => {
//       if (item.favourite) {
//         addToFavourites(item);
//       }
//       const reg_json = copyKeys(item, [
//         "center",
//         "vaccine_date",
//         "vaccine_status",
//         "country",
//       ]);
//       return body.push({
//         event: eventDetail.name,
//         name: item.full_name,
//         communication_preference: 1,
//         email: item.email,
//         gender: item.gender,
//         mobile: item.mobile,
//         city_id: item.city_id,
//         age_group: validateAgeGroup(item.age_group),
//         reg_json,
//         ...addData,
//       });
//     });
//     const registerParticipants = () => {
//       fetchSrcmApi({
//         api: `/api/v2/event-registrations/`,
//         method: "POST",
//         methodParams: body,
//         client: "eventsClient",
//       })
//         .then(() => {
//           dispatch(resetState());
//           if (eventDetail.is_paid_event) {
//             localStorage.setItem("currentPnr", addData.pnr);
//             addNewSale(eventDetail, selectedSku, addData.pnr, body);
//           } else if (fetchPnr) {
//             setLoading(false);
//             getRegistrations(fetchPnr);
//           } else {
//             navigate(`/pnr?pnr=${addData.pnr}&status=success`);
//           }
//         })
//         .catch(() => {
//           // console.log(e);
//         });
//     };

//     registerParticipants();
//   };

//   const prefetchDetails = useCallback(() => {
//     fetchSrcmApi({
//       api: "/api/v2/me/registrations/",
//       methodParams: { page_size: PageSize },
//       client: "eventsClient",
//     })
//       .then((data) => {
//         const fetchedData = data.results.find((item) => item.event === eventId);
//         if (fetchedData) {
//           getRegistrations(fetchedData?.pnr);
//         }
//         setLoading(false);
//       })
//       .catch(() => {
//         setLoading(false);
//       });
//   }, [fetchSrcmApi, eventId, getRegistrations]);

//   useEffect(() => {
//     if (eventId) {
//       const getEventDetails = () => {
//         fetchSrcmApi({
//           api: `/api/v2/events/${eventId}/`,
//           client: "eventsClient",
//         }).then((eventResponse) => {
//           setEventDetail(eventResponse);
//         });
//       };
//       getEventDetails();
//       prefetchDetails();
//     }
//   }, [eventId, fetchSrcmApi, prefetchDetails]);

//   useEffect(() => {
//     if (Object.entries(eventDetail).length) {
//       if (eventDetail.is_paid_event) {
//         if (pricingData.loading) {
//           const getAdminShopPricing = new Promise((resolve) => {
//             shopventory
//               .current({
//                 request: "get-admin-shopventory",
//                 payload: { stock_group: eventId },
//               })
//               .then((result) => {
//                 resolve(result);
//               });
//           });

//           getAdminShopPricing.then((result) => {
//             setPricingList({ loading: false, s: result.data.skus });
//             if (result.data.skus.length) {
//               setSelectedSku(result.data.skus[0]);
//             }
//           });
//         }
//       } else if (!eventDetail.is_paid_event && pricingData.loading) {
//         setPricingList({ loading: false, s: [] });
//       }
//     }
//   }, [eventId, pricingData.loading, eventDetail]);

//   const onCancel = useCallback(
//     (itemId) => {
//       const requestApi = {
//         status: "cancelled",
//       };

//       const afterUpdate = () => {
//         const alertInfo = {
//           title: "Success",
//           message: `Registration has been successfully cancelled.`,
//           confirm_text: "Okay",
//           is_blocking: true,
//         };
//         showAlert(alertInfo);
//         prefetchDetails();
//       };

//       fetchSrcmApi({
//         api: `/api/v2/event-registrations/${itemId}/`,
//         method: "PATCH",
//         client: "eventsClient",
//         methodParams: requestApi,
//       })
//         .then((data) => {
//           afterUpdate();
//           return data;
//         })
//         .catch(() => {
//           const alertInfo = {
//             title: "Error",
//             message: `Sorry, Something went wrong. Please try again later.`,
//             confirm_text: "Okay",
//             is_blocking: true,
//           };
//           showAlert(alertInfo);
//         });
//     },
//     [showAlert, fetchSrcmApi, prefetchDetails]
//   );

//   const setConstrains = () => {
//     if (typeof eventDetail?.event_json?.constraints === "object") {
//       return get(eventDetail, "event_json.constraints", []);
//     }
//     return [];
//   };

//   const checkRegistrationDate = (date) => {
//     const registrationStartDate = new Date(date).getTime();
//     const currentDate = new Date().getTime();
//     return registrationStartDate > currentDate;
//   };

//   return (
//     <div>
//       <Seo title="Kanha santhi vanam | Events Details" />
//       <Layout isSticky wrapperclassName="event_details">
//         <div className="container my-4 event-deatils-container">
//           {loading && (
//             <div className="event_detail_loader">
//               {/* <div style={{position: "relative"}}> */}

//               <div className="detail_loader_innder">
//                 <Loader type="Oval" color="#000" width={30} height={25} />
//                 <span>
//                   {loading && loadingMessage
//                     ? loadingMessage
//                     : "Loading events details"}
//                 </span>
//               </div>
//               {/* </div> */}
//             </div>
//           )}
//           <PeopleSelectionForm
//             registrationText={eventDetail.is_paid_event ? "Proceed to pay" : ""}
//             onRegistrationCallback={onRegistrationCallback}
//             constraints={setConstrains()}
//             styles={styles}
//             // showPois={showPois}
//           />
//           <Breadcrumb items={breadCrumbs} />
//           {fetchPnr && (
//             <>
//               <EventSummary
//                 pnr={fetchPnr}
//                 eventTitle={get(eventDetail, "title", "")}
//                 registrations={prefetchedData || []}
//                 handleAddRegistration={() => dispatch(openParticipantsPanel())}
//                 actions
//                 onCancel={onCancel}
//                 styles={summaryStyles}
//                 enableRegistration
//               />
//               <PricingDetails
//                 selectedPrice={(pd) => setSelectedSku(pd)}
//                 pricingData={pricingData}
//               />
//             </>
//           )}
//           <div className="card">
//             <div className="card-header">
//               <h4 className="card-title">
//                 <span>{eventDetail.title ? eventDetail.title : ""}</span>
//               </h4>
//               <div className="event-se-section">
//                 <span>
//                   {eventDetail.start_datetime &&
//                     getFormattedDate(
//                       eventDetail.start_datetime,
//                       "shortDate"
//                     )}{" "}
//                   -{" "}
//                   {eventDetail.end_datetime &&
//                     getFormattedDate(eventDetail.end_datetime, "shortDate")}
//                 </span>
//               </div>
//             </div>
//             <div className="card-body">
//               <div className="info-box-wrapper">
//                 <div className="info-box">
//                   <h4>Contact Name</h4>
//                   <p>
//                     {eventDetail.event_json
//                       ? get(eventDetail, "event_json.contact_name", "-")
//                       : "-"}
//                   </p>
//                 </div>
//                 <div className="info-box">
//                   <h4>Contact Email</h4>
//                   <p>
//                     {eventDetail.event_json
//                       ? get(eventDetail, "event_json.contact_email", "-")
//                       : "-"}
//                   </p>
//                 </div>
//                 <div className="info-box">
//                   <h4>Venue City</h4>
//                   <p>
//                     {eventDetail.venue_city
//                       ? get(eventDetail, "venue_city.name", "-")
//                       : "-"}
//                   </p>
//                 </div>
//                 <div className="info-box">
//                   <h4>Event Venue</h4>
//                   <p>{eventDetail.is_venue_online ? "Online" : "Offline"}</p>
//                 </div>
//               </div>

//               <EventRegistrations
//                 eventId={eventId}
//                 computePnrPageUrl={computePnrPageUrl}
//               />

//               {eventDetail?.event_json?.allow_ids.length > 0 && (
//                 <div className="event_info">
//                   <h3>Participants Allowed</h3>
//                   <ul>
//                     {eventDetail.event_json.allow_ids.map((item) => (
//                       <li key={item}>{participantsAllowList[item]}</li>
//                     ))}
//                   </ul>
//                 </div>
//               )}
//               <div className="event_info">
//                 <h3>Event Info</h3>
//                 <p>
//                   {eventDetail.event_json && eventDetail.event_json.about
//                     ? eventDetail.event_json.about
//                     : ""}
//                 </p>
//               </div>
//               {!fetchPnr && (
//                 <PricingDetails
//                   selectedPrice={(pd) => setSelectedSku(pd)}
//                   pricingData={pricingData}
//                 />
//               )}
//             </div>
//           </div>
//           <div className="eventDeatils_actions">
//             <div className="info-area">
//               {checkRegistrationDate(eventDetail.reg_starts) && (
//                 <span>
//                   Registration starts on{" "}
//                   {getFormattedDate(eventDetail.reg_starts)}
//                 </span>
//               )}
//               {!checkRegistrationDate(eventDetail.reg_starts) &&
//                 !srcmProfile?.email && <span>Please login to register</span>}
//             </div>
//             <Link to="/events">
//               <button type="button" className="btn btn-info book-a-stay-btn">
//                 Back to Events
//               </button>
//             </Link>
//             {srcmProfile?.email &&
//             eventDetail?.enable_registration &&
//             eventDetail.one_status === "reg_started" &&
//             !fetchPnr ? (
//               <button
//                 type="button"
//                 className="btn registerbtn_events"
//                 onClick={() => dispatch(openParticipantsPanel())}
//               >
//                 Register
//               </button>
//             ) : (
//               <></>
//             )}
//           </div>
//         </div>
//         <br />
//       </Layout>
//     </div>
//   );
// };

// EventDetails.defaultProps = {
//   location: { search: "" },
// };

// EventDetails.propTypes = {
//   location: PropTypes.shape({
//     search: PropTypes.string,
//     origin: PropTypes.string,
//   }),
// };

// export default EventDetails;

export default () => "ok";
